/**
 * created by wang lei
 xxxxx页面
 *
 */
import React from 'react';
import moment from "moment"
import { number } from 'echarts/lib/export';

export default class Sta_Date extends React.Component {
    static defaultProps = {};
    static propTypes = {};
    componentDidMount() {
        this.setDefault()
    }
    // 加载默认架构
    setDefault = () => {
        const { onChange } = this.props;
        // 查询默认数据
        onChange({ fun: "onSearchDefault" })
    };
    render() {
        const { config = {}, value = [null, null] } = this.props;
        const { style = {} } = config;
        let startTime = value?.[0] ? Number(value?.[0]) : null;
        let endTime = value?.[1] ? Number(value?.[1]) : null;
        const statisticStartTime = startTime ? moment(startTime).format("YYYY-MM-DD") : "-";
        const statisticEndTime = endTime ? moment(endTime).format("YYYY-MM-DD") : "-";
        return (
            <div style={{textAlign: "left", ...style }}>
                统计时间：{statisticStartTime} 至 {statisticEndTime}
            </div>
        )
    }

}